import { render, staticRenderFns } from "./order-tracking.vue?vue&type=template&id=0bb9842e&scoped=true&"
import script from "./order-tracking.vue?vue&type=script&lang=js&"
export * from "./order-tracking.vue?vue&type=script&lang=js&"
import style0 from "./order-tracking.vue?vue&type=style&index=0&id=0bb9842e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb9842e",
  null
  
)

export default component.exports